import BaseApiRequest from "./BaseApiRequest";
import { METHOD } from "../Constants";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";
import { PAYSAFE_DETAILS_URL } from "../ApiUrls";

export default class GetPaysafeDetails extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  url = PAYSAFE_DETAILS_URL;

  constructor(applicationId) {
    super();
    this.url = `${this.url}?applicationId=${applicationId}`;
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
